
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class orderDialog extends Vue {
    @Prop({ default: "" }) private title!: string;
    @Prop({ default: false}) private isShowTextarea!: boolean;
    @Prop({ default: false }) private enable!: boolean;
    @Prop({ default: 4 }) private row!: number;
    @Prop({ default: true }) private modalToClose!: boolean;
    @Prop({ default: "30%" }) private width!: string;
    @Prop({ default: true }) private isShowBtn!: boolean;
    @Prop({ default: "15vh" }) private top!: string;
    @Prop({ default: "请输入内容" }) private placeholder!: string;

    private orderDialogVisible: boolean = false;
    private isBtnLoad: boolean = false;
    private inputArea: string = "";

    enterSubmit() {
        if (this.enable) {
            this.submit();
        }
    }

    close() {
        this.$emit("close");
    }

    submit() {
        this.$emit("parentEvent", this.inputArea);
    }
}
